import React from 'react';
import PropTypes from 'prop-types';
import Table from '../../../core/form/Table';
import Button from '../../../core/form/Button';
import ImagePreview from '../../../core/layout/ImagePreview';
import { Roles } from '../../../core/util';

const ModuleCustomizationList = (props) => (
  <Table
    fetching={props.fetching}
    columns={[
      {
        label: 'Course',
        path: 'module.course.name',
      },
      {
        label: 'Module',
        path: 'module.name',
      },
      ...(localStorage.role === Roles.ADMIN
        ? [
            {
              label: 'Distributor',
              path: 'distributor.name',
            },
          ]
        : []),
      {
        label: 'Icon',
        path: 'iconUrl',
        render: (value) => <ImagePreview src={value} />,
      },
      {
        label: 'Actions',
        path: 'action',
        width: '80px',
        render: (cell, row) => <Button icon="delete" onClick={() => props.onDelete(row)} />,
      },
    ]}
    rows={props.customizations}
    pagination={props.pagination}
    onChange={props.onChange}
  />
);

ModuleCustomizationList.propTypes = {
  customizations: PropTypes.array.isRequired,
  fetching: PropTypes.bool,
  pagination: PropTypes.object,
  onChange: PropTypes.func,
  onDelete: PropTypes.func.isRequired,
};

ModuleCustomizationList.defaultProps = {
  fetching: false,
  pagination: null,
  onChange: null,
};

export default ModuleCustomizationList;
